import { Box } from '@chakra-ui/react'
import { ColumnDef } from '@tanstack/react-table'
import { Link } from 'react-router-dom'

export const PROPERTY_COLUMNS: ColumnDef<any>[] = [
  {
    header: 'ID',
    accessorKey: 'id',
    size: 100,
    cell: (row: any) => {
      const value = row.cell.getValue()
      return (
        <Box
          fontWeight={'500'}
          _hover={{
            color: 'barColor.50',
            textDecor: 'underline',
          }}
          color="brand.300"
        >
          <Link to={`/property-details/${value}`}>{value}</Link>
        </Box>
      )
    },
  },
  {
    header: 'property.propertyTable.address',
    accessorKey: 'streetAddress',
  },
  {
    header: 'property.propertyTable.city',
    accessorKey: 'city',
  },
  {
    header: 'property.propertyTable.state',
    accessorKey: 'state',
  },
  {
    header: 'property.propertyTable.zip',
    accessorKey: 'zipCode',
  },
  {
    header: 'property.propertyTable.market',
    accessorKey: 'market',
    accessorFn: (cellInfo: any) => cellInfo?.market?.metropolitanServiceArea,
  },
  {
    header: 'property.propertyTable.client',
    accessorKey: 'clientName',
  },
  {
    header: 'property.propertyTable.unitNo',
    accessorKey: 'unitNo',
  }
]
